export enum PaymentReportGrouping {
  METHOD = "METHOD",
  TYPE = "TYPE",
  PROVIDER = "PROVIDER",
  CATEGORY = "CATEGORY",
}
